// console.log("team popups script loaded");

// (function () {
//   function initTeamPopups() {
//     document.addEventListener("click", function (e) {
//       const trigger = e.target.closest(".team-popup-trigger");
//       const modal = document.getElementById("teamModal");
//       const content = document.getElementById("teamModalContent");

//       if (!modal || !content) return;

//       // Close
//       if (e.target.closest("[data-close]")) {
//         modal.classList.remove("is-open");
//         modal.setAttribute("aria-hidden", "true");
//         content.innerHTML = "";
//         document.documentElement.classList.remove("team-modal-open");
//         return;
//       }

//       // Open
//       if (!trigger) return;
//       e.preventDefault();

//       const key = trigger.getAttribute("data-member");
//       if (!key) return;

//       const template = document.getElementById("member-" + key);
//       if (!template) return;

//       content.innerHTML = template.innerHTML;
//       modal.classList.add("is-open");
//       modal.setAttribute("aria-hidden", "false");
//       document.documentElement.classList.add("team-modal-open");
//     });

//     document.addEventListener("keydown", function (e) {
//       if (e.key !== "Escape") return;

//       const modal = document.getElementById("teamModal");
//       if (!modal || !modal.classList.contains("is-open")) return;

//       modal.classList.remove("is-open");
//       modal.setAttribute("aria-hidden", "true");
//       const content = document.getElementById("teamModalContent");
//       if (content) content.innerHTML = "";
//       document.documentElement.classList.remove("team-modal-open");
//     });
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", initTeamPopups);
//   } else {
//     initTeamPopups();
//   }
// })();



// console.log("✅ Team popups JS loaded");

// (function () {
//   if (window.__TEAM_POPUPS_INITED__) {
//     console.log("ℹ️ Team popups already initialized, skipping duplicate.");
//     return;
//   }
//   window.__TEAM_POPUPS_INITED__ = true;

  

//   function openModal(key) {
//     const modal = document.getElementById("teamModal");
//     const content = document.getElementById("teamModalContent");
//     const template = document.getElementById("member-" + key);

//     console.log("openModal()", { key, modal: !!modal, content: !!content, template: !!template });

//     if (!modal) return console.error("❌ #teamModal not found on page");
//     if (!content) return console.error("❌ #teamModalContent not found inside modal");
//     if (!template) return console.error(`❌ Template #member-${key} not found (ID mismatch)`);

//     content.innerHTML = template.innerHTML;

//     // Open + fallback styles (prevents CSS conflicts)
//     modal.classList.add("is-open");
//     modal.setAttribute("aria-hidden", "false");
//     modal.style.display = "block";
//     modal.style.visibility = "visible";
//     modal.style.opacity = "1";
//     modal.style.zIndex = "999999";

//     document.documentElement.classList.add("team-modal-open");
//   }

//   function closeModal() {
//     const modal = document.getElementById("teamModal");
//     const content = document.getElementById("teamModalContent");
//     if (!modal || !content) return;

//     modal.classList.remove("is-open");
//     modal.setAttribute("aria-hidden", "true");
//     content.innerHTML = "";

//     // remove forced inline styles 
//     modal.style.display = "";
//     modal.style.visibility = "";
//     modal.style.opacity = "";
//     modal.style.zIndex = "";

//     document.documentElement.classList.remove("team-modal-open");
//   }

//   // Use CAPTURE phase so nothing can block the click
//   document.addEventListener(
//     "click",
//     function (e) {
//       const trigger = e.target.closest(".team-popup-trigger");

//       // Close
//       if (e.target.closest("[data-close]")) {
//         console.log("✅ Close clicked");
//         closeModal();
//         return;
//       }

//       // Open
//       if (!trigger) return;

//       const key = trigger.getAttribute("data-member");
//       console.log("✅ Trigger clicked", { trigger, key });

//       if (!key) return console.error("❌ data-member missing on trigger");

//       e.preventDefault();
//       openModal(key);
//     },
//     true
//   );

//   document.addEventListener("keydown", function (e) {
//     if (e.key === "Escape") {
//       console.log("✅ ESC pressed (closing)");
//       closeModal();
//     }
//   });
// })();

// console.log("✅ Team popups JS loaded");

// (function () {
//   if (window.__TEAM_POPUPS_INITED__) return;
//   window.__TEAM_POPUPS_INITED__ = true;

//   function wakeImages(scope) {
//     if (!scope) return;

//     // Fix <img> lazy attributes
//     scope.querySelectorAll("img").forEach((img) => {
//       const src =
//         img.getAttribute("data-src") ||
//         img.getAttribute("data-pf-src") ||
//         img.getAttribute("data-lazy-src") ||
//         img.getAttribute("data-original");

//       if ((!img.getAttribute("src") || img.getAttribute("src") === "") && src) {
//         img.setAttribute("src", src);
//       }

//       const srcset =
//         img.getAttribute("data-srcset") ||
//         img.getAttribute("data-pf-srcset") ||
//         img.getAttribute("data-lazy-srcset");

//       if ((!img.getAttribute("srcset") || img.getAttribute("srcset") === "") && srcset) {
//         img.setAttribute("srcset", srcset);
//       }
//     });

//     // Fix <picture><source> lazy attributes (common in desktop)
//     scope.querySelectorAll("source").forEach((source) => {
//       const ss =
//         source.getAttribute("data-srcset") ||
//         source.getAttribute("data-pf-srcset") ||
//         source.getAttribute("data-lazy-srcset");
//       if ((!source.getAttribute("srcset") || source.getAttribute("srcset") === "") && ss) {
//         source.setAttribute("srcset", ss);
//       }
//     });

//     // Trigger browser to re-evaluate picture sources
//     scope.querySelectorAll("picture img").forEach((img) => {
//       const current = img.getAttribute("src");
//       if (current) img.setAttribute("src", current);
//     });
//   }

//   function openModal(key) {
//     const modal = document.getElementById("teamModal");
//     const content = document.getElementById("teamModalContent");
//     const template = document.getElementById("member-" + key);

//     if (!modal || !content || !template) {
//       console.warn("❌ Missing modal/content/template", {
//         modal: !!modal,
//         content: !!content,
//         template: !!template,
//         key,
//       });
//       return;
//     }

//     content.innerHTML = template.innerHTML;

//     // Wake up lazy images after injecting HTML
//     wakeImages(content);

//     modal.classList.add("is-open");
//     modal.setAttribute("aria-hidden", "false");
//     document.documentElement.classList.add("team-modal-open");
//   }

//   function closeModal() {
//     const modal = document.getElementById("teamModal");
//     const content = document.getElementById("teamModalContent");
//     if (!modal || !content) return;

//     modal.classList.remove("is-open");
//     modal.setAttribute("aria-hidden", "true");
//     content.innerHTML = "";
//     document.documentElement.classList.remove("team-modal-open");
//   }

//   // CLICK HANDLER
//   document.addEventListener(
//     "click",
//     function (e) {
//       try {
//         // Close
//         if (e.target.closest("[data-close]")) {
//           e.preventDefault();
//           closeModal();
//           return;
//         }

//         // Open
//         const trigger = e.target.closest(".team-popup-trigger");
//         if (!trigger) return;

//         e.preventDefault();
//         const key = trigger.getAttribute("data-member");
//         if (!key) return;

//         openModal(key);
//       } catch (err) {
//         console.error("❌ Team popup JS error:", err);
//       }
//     },
//     true
//   );

//   // ESC TO CLOSE
//   document.addEventListener("keydown", function (e) {
//     if (e.key === "Escape") closeModal();
//   });
// })();


console.log("✅ Team popups JS loaded (MOVE templates)");

(function () {
  if (window.__TEAM_POPUPS_INITED__) return;
  window.__TEAM_POPUPS_INITED__ = true;

  // Store original positions so we can put templates back
  const originalPos = new Map(); // key -> { parent, nextSibling }

  function openByKey(key) {
    const modal = document.getElementById("teamModal");
    const content = document.getElementById("teamModalContent");
    const template = document.getElementById("member-" + key);

    console.log("openByKey()", { key, modal: !!modal, content: !!content, template: !!template });

    if (!modal || !content || !template) return;

    // Save original location only once
    if (!originalPos.has(key)) {
      originalPos.set(key, { parent: template.parentNode, nextSibling: template.nextSibling });
    }

    // Clear modal content, then MOVE the actual template node into modal
    content.innerHTML = "";
    content.appendChild(template);

    // Open modal
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    document.documentElement.classList.add("team-modal-open");
    document.body.classList.add("team-modal-open");
  }

  function closeModal() {
  const modal = document.getElementById("teamModal");
  const content = document.getElementById("teamModalContent");
  if (!modal || !content) return;

  // If already closing, ignore
  if (modal.classList.contains("is-closing")) return;

  // Start close animation
  modal.classList.add("is-closing");
  modal.classList.remove("is-open");

  // Wait for CSS transition to finish
  window.setTimeout(() => {
    // Move templates back (keep your existing move-back logic here)
    originalPos.forEach((pos, key) => {
      const el = document.getElementById("member-" + key);
      if (!el || !pos.parent) return;

      if (pos.nextSibling && pos.nextSibling.parentNode === pos.parent) {
        pos.parent.insertBefore(el, pos.nextSibling);
      } else {
        pos.parent.appendChild(el);
      }
    });

    content.innerHTML = "";
    modal.classList.remove("is-closing");
    modal.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove("team-modal-open");
    document.body.classList.remove("team-modal-open");
  }, 520); // match .25s in CSS
}


  // Capture phase so nothing blocks clicks
  document.addEventListener(
    "click",
    function (e) {
      // Close
      if (e.target.closest("[data-close]")) {
        e.preventDefault();
        closeModal();
        return;
      }

      // Open
      const trigger = e.target.closest(".team-popup-trigger");
      if (!trigger) return;

      const key = trigger.getAttribute("data-member");
      if (!key) return;

      e.preventDefault();
      openByKey(key);
    },
    true
  );

  // ESC closes
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });
})();
